import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const ArrowUpIcon: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg viewBox="4 4 16 16" {...props}>
        <path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" fill={color || "currentColor"} />
    </svg>
);

export default ArrowUpIcon;